import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm.queryResponse.list_approval &&
      _vm.queryResponse.list_approval.length == 0
        ? _c("StateComponent", {
            attrs: {
              state: "empty_state",
              title: _vm.$t("my_pendings.no_requests"),
              subtitle: _vm.$t("my_pendings.no_requests_subtitle"),
            },
          })
        : _c(VDataTable, {
            key: "table_" + _vm.table_access,
            staticClass: "table-inca",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              "hide-default-footer": "",
              items: _vm.queryResponse.list_approval,
              headers: _vm.tableFields,
              search: _vm.filter,
              filterIncludedFields: _vm.filterOn,
              "sticky-header": true,
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
              "item-key": "id_firestore",
              "show-select":
                _vm.typeFlow == "ACCESS" && _vm.status_filter == "REVISION",
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.tableReference.tableId",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", { staticClass: "table-name" }, [
                        _vm._v(_vm._s(item.tableReference.tableId)),
                      ]),
                      _c("br"),
                      _c(
                        "a",
                        {
                          staticClass: "compose-name",
                          attrs: { title: item.id },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("joinTableReference")(item.tableReference)
                            )
                          ),
                        ]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "header.data-table-select",
                fn: function (ref) {
                  return undefined
                },
              },
              {
                key: "item.data-table-select",
                fn: function (ref) {
                  var item = ref.item
                  var isSelected = ref.isSelected
                  var select = ref.select
                  return [
                    item.status == "REVISION"
                      ? _c(VCheckbox, {
                          on: {
                            change: function ($event) {
                              return _vm.onItemSelected(
                                $event,
                                item,
                                _vm.openRequestAccess,
                                _vm.typeFlow
                              )
                            },
                          },
                          model: {
                            value: isSelected,
                            callback: function ($$v) {
                              isSelected = $$v
                            },
                            expression: "isSelected",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "item.created",
                fn: function (ref) {
                  var item = ref.item
                  return [_c("b", [_vm._v(_vm._s(item.created))])]
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openRequestAccess(item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("icon-view"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_pendings.view_request"))),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.rows_selected,
              callback: function ($$v) {
                _vm.rows_selected = $$v
              },
              expression: "rows_selected",
            },
          }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ACCESS,
          attrs: { title: _vm.$t("my_pendings.view_request"), width: 1800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-response", {
                key: _vm.key_access,
                ref: _vm.MODAL_NAME_ACCESS + "_body",
                attrs: {
                  tplToWork: _vm.acccessToAssign,
                  isOnlyView: _vm.isOnlyView,
                },
                on: {
                  submit: _vm.acceptRequestAccess,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.DIALOG_ADD_ACCESS_REQUEST].onClose()
                  },
                  refuse: _vm.refuseRequest,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      attrs: {
                        variant: "primary",
                        color: "success",
                        outlined: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$refs[
                            _vm.DIALOG_CONFIRM_AUTO_APPROVE
                          ].onOpen()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("flash_on"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.approve_automatic"))),
                    ]
                  )
                : _vm._e(),
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "secondary", outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[_vm.MODAL_NAME_ACCESS + "_body"].onRefuse()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("not_interested"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.reject"))),
                    ]
                  )
                : _vm._e(),
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      attrs: { variant: "primary", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[_vm.MODAL_NAME_ACCESS + "_body"].approve()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("check"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.accept"))),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_METADATA_CHANGE,
          attrs: {
            title: _vm.$t("my_pendings.view_change_metadata"),
            width: 1200,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-change-response", {
                key: _vm.key_meta,
                ref: _vm.MODAL_NAME_METADATA_CHANGE + "_body",
                attrs: {
                  userRequestMetadata: _vm.acccessToAssign,
                  serverActualMetadata: _vm.serverActualMetadata,
                  isOnlyView: _vm.isOnlyView,
                },
                on: {
                  submit: _vm.acceptRequestMetadata,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_CHANGE].onClose()
                  },
                  refuse: _vm.refuseRequest,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: { outlined: "", color: "secondary", size: "sm" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NAME_METADATA_CHANGE + "_body"
                          ].onRefuse()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("not_interested"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.reject"))),
                    ]
                  )
                : _vm._e(),
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: {
                        color: "primary",
                        variant: "primary",
                        size: "sm",
                      },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.MODAL_NAME_METADATA_CHANGE + "_body"
                          ].approve()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("check"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.accept"))),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_ADD_ACCESS_REQUEST,
          attrs: {
            title: _vm.$t("my_pendings.view_request"),
            width: 1200,
            showCancelButton: false,
          },
          on: {
            onCloseClick: function ($event) {
              return _vm.onCancelModal()
            },
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-response", {
                key: _vm.key_access,
                ref: _vm.DIALOG_ADD_ACCESS_REQUEST + "_body",
                attrs: { tplToWork: _vm.acccessToAssign },
                on: {
                  onAccept: _vm.onAddItem,
                  submit: _vm.acceptRequestAccess,
                  cancel: function ($event) {
                    return _vm.onCancel()
                  },
                  refuse: _vm.refuseRequest,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "grey", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.onCancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btns.cancel")))]
              ),
              _c(
                VBtn,
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.DIALOG_ADD_ACCESS_REQUEST + "_body"
                      ].onAccept()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("add"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("common.massive"))),
                ]
              ),
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: { outlined: "", color: "warning", size: "sm" },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.DIALOG_ADD_ACCESS_REQUEST + "_body"
                          ].onRefuse()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("not_interested"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("btns.reject"))),
                    ]
                  )
                : _vm._e(),
              !_vm.isOnlyView
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-2",
                      attrs: {
                        color: "primary",
                        variant: "primary",
                        size: "sm",
                      },
                      on: {
                        click: function ($event) {
                          _vm.$refs[
                            _vm.DIALOG_ADD_ACCESS_REQUEST + "_body"
                          ].approve()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("check"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("common.approve"))),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.DIALOG_ADD_CHANGE_METADATA,
          attrs: {
            title: _vm.$t("my_pendings.view_change_metadata"),
            width: 1200,
            showCancelButton: false,
          },
          on: {
            onCloseClick: function ($event) {
              return _vm.onCancelModal()
            },
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-change-response", {
                key: _vm.key_meta,
                ref: _vm.DIALOG_ADD_CHANGE_METADATA + "_body",
                attrs: {
                  userRequestMetadata: _vm.acccessToAssign,
                  serverActualMetadata: _vm.serverActualMetadata,
                  isOnlyView: _vm.isOnlyView,
                },
                on: {
                  submit: _vm.onAddItem,
                  cancel: function ($event) {
                    return _vm.onCancel()
                  },
                  refuse: _vm.refuseRequest,
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { outlined: "", color: "secondary", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.onCancel()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("not_interested"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.cancel"))),
                ]
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { color: "primary", variant: "primary", size: "sm" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[
                        _vm.DIALOG_ADD_CHANGE_METADATA + "_body"
                      ].onAccept()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("check"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CONFIRM_AUTO_APPROVE,
        attrs: { text: _vm.$t("my_tasks.modals.auto_approve_confirm") },
        on: { onConfirm: _vm.onConfirmAutoApprove },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }